module.exports = __webpack_public_path__ + "static/hero-video.dac21bf5.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/pages/hero-video.mp4
// module id = 542
// module chunks = 35783957827783